import React from 'react';
import styled from 'styled-components';
import {COLORS, SIZES, ToggleButton, ToggleButtons} from '@fupa/fupa-uikit';
import {FPNavLink} from 'app/components/links/link';

const InnerNavigation = styled.div`
  padding: ${SIZES['8']} ${SIZES['14']};
  background-color: ${COLORS.white};
  margin-bottom: ${SIZES['8']};
`;

const CustomToggleNavButton = styled(ToggleButton)`
  &&& {
    width: 100%;
    max-width: ${SIZES['116']};
    min-width: ${SIZES['48']};
    padding: 0.2rem 0.5rem;
    &:focus {
      background-color: ${COLORS.fupaSecondaryFocused};
      border-color: ${COLORS.fupaSecondaryFocused};
      span {
        color: ${COLORS.white};
      }
    }
    @media only screen and (max-width: 360px) {
      padding-left: ${SIZES['8']};
      padding-right: ${SIZES['8']};
    }
  }
`;

const ButtonGroup = ({activeValue, onChange, buttons}) => {
  const children = buttons.map(button => {
    return (
      <CustomToggleNavButton key={button.value} component={FPNavLink} exact to={button.url} value={button.value}>
        {button.label}
      </CustomToggleNavButton>
    );
  });

  return (
    <InnerNavigation>
      <ToggleButtons activeValue={activeValue} onChange={value => onChange(value)}>
        {children}
      </ToggleButtons>
    </InnerNavigation>
  );
};
export {ButtonGroup};
